
import {
  GET_AR_AGING_SUMMARY_TERM_WISE_REQUEST,
  GET_AR_AGING_SUMMARY_TERM_WISE_SUCCESS,
  GET_AR_AGING_SUMMARY_TERM_WISE_ERROR
} from "../actions/types";

export const arAgingSummaryTermWise = (state = [], action) => {
  const { type, payload } = action;
  switch (type) {
    case GET_AR_AGING_SUMMARY_TERM_WISE_REQUEST:
      return {
        loading: true,
      };
    case GET_AR_AGING_SUMMARY_TERM_WISE_SUCCESS:
      return {
        ...state,
        loading: false,
        payload,
      };
    case GET_AR_AGING_SUMMARY_TERM_WISE_ERROR:
      return {
        ...state,
        loading: false,
        payload,
      };

    default: {
      return state;
    }
  }
};